import * as React from 'react';
import { connect } from 'react-redux';

import {
  downloadShippingAddresses,
  fetchCreatorsFirstTask,
  resetCreatorsFirstTask
} from 'modules/campaigns/reducers/campaignShippingAddresses';
import Spinner from 'components/spinner/Spinner';
import ShippingAddresses from 'modules/subcampaigns/components/shipping-adresses/ShippingAddresses';
import ShippingAddressesDownloadButton from 'modules/subcampaigns/components/shipping-adresses/download-button/ShippingAddressesDownloadButton';

import { __t, applyTranslations } from 'utils/language';

import type { Deliverable, Subcampaign } from 'types';
import type { AddressEntry } from 'modules/subcampaigns/components/shipping-adresses/ShippingAddresses';

import './shipping-addresses-section.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

applyTranslations(require('./shipping-addresses-section.i18n.json'));

type OwnProps = {
  campaignId: number,
  onClose: () => void
};

type StateProps = {
  subcampaigns: Array<Subcampaign>,
  deliverableData: {
    [x: number]: Deliverable
  },
  isLoading: boolean
};

type DispatchProps = {
  dispatchFetchCreatorsFirstTask: () => Promise<void>,
  dispatchResetCreatorsFirstTask: () => void,
  dispatchDownloadShippingAddresses: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class ShippingAddressesSection extends React.PureComponent<Props> {
  componentDidMount() {
    const { dispatchFetchCreatorsFirstTask } = this.props;
    dispatchFetchCreatorsFirstTask();
  }

  componentWillUnmount() {
    const { dispatchResetCreatorsFirstTask } = this.props;
    dispatchResetCreatorsFirstTask();
  }

  collectEntries() {
    const { subcampaigns = [], deliverableData } = this.props;

    return subcampaigns
      .map<AddressEntry>(({ id, creatorProfile, shippingAddress, offer }) => {
        const deliverable = deliverableData[offer.id] || {};
        const dateKeyOfFirstTask = deliverable.startDate;

        return {
          id, // for SortableTable key
          subcampaignId: id,
          creatorProfile,
          shippingAddress,
          dateOfFirstTask: (dateKeyOfFirstTask) ? new Date(dateKeyOfFirstTask) : undefined
        };
      });
  }

  renderHeader(): React.ReactNode {
    const { dispatchDownloadShippingAddresses, onClose } = this.props;

    return (
      <div className="shipping-addresses-section__header">
        <div className="shipping-addresses-section__title">
          {__t('shipping_addresses_section.title')}
        </div>
        <div className="shipping-addresses-section__action">
          <ShippingAddressesDownloadButton onClick={dispatchDownloadShippingAddresses} />
        </div>
        <div className="shipping-addresses-section__action">
          <SVGDynamicIcon
            name="cross-custom-fg"
            customColor="grey"
            width={12}
            height={12}
            onClick={onClose}
          />
        </div>
      </div>
    );
  }

  renderContent(): React.ReactNode {
    const { isLoading, campaignId } = this.props;

    if (isLoading) {
      return (
        <Spinner
          position="inline"
          size="small"
          color="light"
        />
      );
    }

    return (
      <ShippingAddresses
        campaignId={campaignId}
        entries={this.collectEntries()}
      />
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderHeader()}
        {this.renderContent()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ campaignShippingAddresses, campaignParticipants }): StateProps => ({
  isLoading: campaignShippingAddresses.isLoading,
  subcampaigns: campaignParticipants.list,
  deliverableData: campaignShippingAddresses.deliverableData
});

const mapDispatchToProps = (dispatch, ownProps: OwnProps): DispatchProps => ({
  dispatchFetchCreatorsFirstTask: () => dispatch(fetchCreatorsFirstTask(ownProps.campaignId)),
  dispatchResetCreatorsFirstTask: () => dispatch(resetCreatorsFirstTask()),
  dispatchDownloadShippingAddresses: () => dispatch(downloadShippingAddresses(ownProps.campaignId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddressesSection);
